import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustItem {
  id: string;
  icon: string;
  title: string;
  description: string;
}

const TrustSection = () => {
  const trustItems: TrustItem[] = [
    {
      id: '1',
      icon: 'UserGroupIcon',
      title: 'Dietician Available',
      description: 'Expert dieticians available to provide personalised nutrition plans and dietary guidance to support your training and health goals'
    },
    {
      id: '2',
      icon: 'AcademicCapIcon',
      title: 'Certified Professionals',
      description: 'All coaches hold national and international certifications in sports training, fitness instruction, and first aid'
    },
    {
      id: '3',
      icon: 'ClipboardDocumentCheckIcon',
      title: 'Safety Protocols',
      description: 'Strict adherence to safety guidelines with regular equipment maintenance and emergency response procedures'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-primary mb-4">
            Your Safety is Our Priority
          </h2>
          <p className="text-base lg:text-lg text-text-secondary max-w-3xl mx-auto">
            We maintain the highest standards of safety, professionalism, and care to ensure a secure training environment for all members
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {trustItems.map((item) => (
            <div
              key={item.id}
              className="bg-card rounded-lg shadow-card hover:shadow-hover transition-all duration-300 p-6 text-center border border-border"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-4">
                <Icon name={item.icon as any} size={32} variant="solid" className="text-accent" />
              </div>
              <h3 className="text-lg lg:text-xl font-heading font-bold text-primary mb-3">
                {item.title}
              </h3>
              <p className="text-sm lg:text-base text-text-secondary leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 bg-card rounded-lg shadow-card p-6 lg:p-8 border border-border">
          <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-4 lg:space-y-0 lg:space-x-6">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name="PhoneIcon" size={32} variant="solid" className="text-success" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-xl lg:text-2xl font-heading font-bold text-primary mb-2">
                Emergency Contact
              </h3>
              <p className="text-sm lg:text-base text-text-secondary font-body leading-relaxed mb-4">
                For urgent matters or emergencies during training hours, contact our emergency response team immediately
              </p>
              <a
                href="tel:+919871010610"
                className="inline-flex items-center space-x-2 text-accent hover:text-accent/80 font-heading font-semibold text-base lg:text-lg transition-colors"
              >
                <span>+91 98710 10610</span>
                <Icon name="ArrowRightIcon" size={20} variant="outline" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;